import React, { useContext, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import successIcon from "../../assets/images/SuccesMem.svg";
import { Language } from "../../App";

export default function SuccessMemeberModal({ show, onHide, onEdit, onGotIt }) {
  const { lang } = useContext(Language);
  // Same manual body-scroll-lock pattern used by the other custom modals in
  // this app (e.g. FollowersFollowingModal, ModalReportUser) — react-bootstrap's
  // own lock wasn't reliably re-enabling scroll on close. `html` has no
  // overflow set in main.css, so the page scrollbar actually belongs to
  // <html>, not <body> — locking body alone doesn't stop it.
  useEffect(() => {
    document.documentElement.style.overflow = show ? "hidden" : "";
    document.body.style.overflow = show ? "hidden" : "";
    return () => {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    };
  }, [show]);

  // Same curtain-modal pattern as ApplyMentorShip.jsx / NewCourseDetail2.0.jsx's
  // VideoModal — plain backdrop + content divs animated with @keyframes,
  // not react-bootstrap's Modal/Fade, so open and close are both immediate
  // and symmetric instead of gated behind a JS timeout. No toggle prop here
  // (react-bootstrap's show/onHide API, not reactstrap's isOpen/toggle) —
  // the callback passed in IS what actually flips `show` back to false, so
  // it only fires once the curtain has finished sliding back up.
  const [isClosing, setIsClosing] = useState(false);
  const closeThen = (callback) => {
    setIsClosing(true);
    setTimeout(() => {
      setIsClosing(false);
      callback?.();
    }, 800);
  };

  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape") closeThen(() => onHide?.());
    };
    if (show) document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show]);

  if (!show && !isClosing) return null;

  return (
    // backdrop is intentionally not clickable-to-close — matches the
    // original Modal's backdrop="static" behavior (Escape and the button
    // below are the only ways out).
    <div className={`sm-curtain-backdrop ${isClosing ? "closing" : ""}`}>
      <style>{`
        /* Same curtain-modal pattern as ApplyMentorShip.jsx — plain
           backdrop + content divs animated with @keyframes, driven by our
           own isClosing state so open and close are both immediate and
           symmetric. */
        .sm-curtain-backdrop {
          position: fixed;
          inset: 0;
          background-color: rgba(0, 0, 0, 0.5);
          z-index: 1050;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 20px;
          overflow-y: auto;
          animation: smBackdropFadeIn 0.8s ease-out forwards;
        }
        .sm-curtain-backdrop.closing {
          animation: smBackdropFadeOut 0.8s ease-out forwards;
        }
        .sm-curtain-content {
          position: relative;
          width: 531px;
          max-width: 92vw;
          height: 405px;
          max-height: 92vh;
          margin: auto;
          font-family: var(--app-font-family);
          border-radius: 26px;
          overflow: hidden;
          background: #fff;
          transform: translateY(-100vh);
          animation: smCurtainOpen 0.8s ease-out forwards;
        }
        .sm-curtain-content.closing {
          animation: smCurtainClose 0.8s cubic-bezier(0.175, 0.885, 0.32, 1.275) forwards;
        }
        @keyframes smBackdropFadeIn {
          0% { opacity: 0; }
          100% { opacity: 1; }
        }
        @keyframes smBackdropFadeOut {
          0% { opacity: 1; }
          100% { opacity: 0; }
        }
        @keyframes smCurtainOpen {
          0% { transform: translateY(-100vh); }
          100% { transform: translateY(0); }
        }
        @keyframes smCurtainClose {
          0% { transform: translateY(0); }
          100% { transform: translateY(-100vh); }
        }
        @media (prefers-reduced-motion: reduce) {
          .sm-curtain-backdrop, .sm-curtain-content {
            animation: none !important;
          }
        }
      `}</style>
      <div
        className={`sm-curtain-content ${isClosing ? "closing" : ""}`}
        onClick={(e) => e.stopPropagation()}
      >
      <div
        style={{
          borderRadius: "26px",
          padding: "40px 40px 24px",
          textAlign: "center",
          height: "100%",
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "49px",
          background:
            "linear-gradient(180deg, #DAFAFF 0px, #EFFDFF 40px, #FFFFFF 140px, #FFFFFF 100%)",
        }}
      >
        {/* Icon */}
        <img src={successIcon} alt=""  style={{ display: "block" }} />

        <div>
          {/* Title */}
          <h5
            style={{
              fontWeight: 700,
              fontSize: "20px",
              color: "#0F1A2B",
              margin: "0 0 12px",
            }}
          >
            {lang?.mentorship_application_submitted_title || "Mentor Application Submitted"}
          </h5>

          {/* Description */}
          <p
            style={{
              fontSize: "12px",
              color: "#5F6673",
              lineHeight: 1.6,
              margin: 0,
              fontWeight:400,
              padding: "0 6px",
            }}
          >
            {lang?.mentorship_application_submitted_desc || "Your application has been submitted successfully. Our team will review your request, and you'll be notified once your mentor profile has been approved."}
          </p>
        </div>

        <div style={{ width: "100%" }}>
          {/* Edit Submitted Request — solid pill */}
          <Button
           onClick={() => closeThen(() => onGotIt?.())}
            style={{
              display: "block",
              width: "100%",
              background: "#00BADA",
              border: "none",
              borderRadius: "999px",
              padding: "12px 1rem",
              fontWeight: 700,
              fontSize: "0.95rem",
              color: "#ffffff",
             
            }}
          >
         {lang?.mentorship_back_to_mentorship_button || "Back to Mentorship"}
          </Button>

          {/* Got It, Thanks — plain text link */}
          {/* <button
            type="button"
            onClick={onGotIt}
            style={{
              background: "transparent",
              border: "none",
              fontWeight: 600,
              fontSize: "0.9rem",
              color: "#0F1A2B",
              cursor: "pointer",
              padding: 0,
            }}
          >
            Got It, Thanks
          </button> */}
        </div>
      </div>
      </div>
      </div>
  );
}
